import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "shareAndroidFilled"
const ShareAndroidFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18 2.25C19.657 2.25 21 3.593 21 5.25S19.657 8.25 18 8.25C17.15 8.25 16.382 7.895 15.836 7.326L8.9 11.23Q8.999 11.599 9 12 8.998 12.4 8.899 12.77L15.836 16.674C16.382 16.104 17.15 15.75 18 15.75 19.657 15.75 21 17.093 21 18.75S19.657 21.75 18 21.75 15 20.407 15 18.75Q15.001 18.349 15.1 17.979L8.163 14.076C7.617 14.645 6.85 15 6 15 4.343 15 3 13.657 3 12S4.343 9 6 9C6.85 9 7.617 9.354 8.163 9.922L15.1 6.021Q15.001 5.65 15 5.25C15 3.593 16.343 2.25 18 2.25" />
        </svg>
      }
    </span>
  )
}
export default ShareAndroidFilledIcon
